import { ChainId } from '../domain/flow'

export const TRANSACTION_EXPLORER_URL_BY_CHAIN_ID: Readonly<Record<number, string>> = {
  [ChainId.ETHEREUM]: 'https://etherscan.io/tx/',
  [ChainId.ARBITRUM]: 'https://arbiscan.io/tx/',
  [ChainId.BASE]: 'https://basescan.org/tx/',
  [ChainId.OPTIMISM]: 'https://optimistic.etherscan.io/tx/',
  [ChainId.SOLANA]: 'https://solscan.io/tx/',
}

export const TON_TRANSACTION_EXPLORER_URL = 'https://tonviewer.com/transaction/'
